import {useSelector} from 'react-redux';
import {TypedUseSelectorHook} from 'react-redux';
import {AppStateType} from '../Store/types';

const useAppSelector: TypedUseSelectorHook<AppStateType> = useSelector;

export default useAppSelector;
